import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SubscribeService {

  constructor(private http: HttpClient) { }

  Subscribe(value) {
    const userData = {
      email: value.email
    };
    this.http.post('http://localhost:3000/user/subscribe', userData)
      .subscribe((response: any) => {
        Swal.fire({
          icon: 'success',
          title: 'You Subscribed Succesfully',
        });
      });
  }
}
